export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ]

}
